export function extractQuantity(subject: string): string {
  const qtyRegex = /(^[0-9]*(\.*?[0-9]*)\*)/;
  if (qtyRegex.test(subject)) {
    return qtyRegex.exec(subject)[0].replace('*', '');
  }
  return '';
}

export function extractQuantityAndQuery(subject: string): {
  quantity: number;
  query: string;
} {
  const quantity = extractQuantity(subject);
  if (!quantity) {
    return { quantity: 1, query: subject };
  }
  return {
    quantity: parseFloat(quantity),
    query: subject.replace(`${quantity}*`, '')
  };
}
